import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ff7f110e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = { class: "DialogBody" }
const _hoisted_4 = { class: "DialogSection" }
const _hoisted_5 = { class: "DialogSectionTitle" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_7 = { class: "DialogSection" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_9 = { class: "DialogSection F1_5em" }
const _hoisted_10 = { class: "F-Bold" }
const _hoisted_11 = {
  key: 0,
  class: "CookiesDialogFooter"
}
const _hoisted_12 = {
  class: "F-Bold",
  style: {"margin":"auto 1em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_CookiesTable = _resolveComponent("CookiesTable")!
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: 'CookiesDialog_' + _ctx.DialogIndex,
      class: "CookiesDialogdBody"
    }, [
      (_ctx.Saving)
        ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.Loading.length > 0)
        ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 1 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.Translate('Available Items')), 1),
            _createVNode(_component_CookiesTable, {
              onDeleteRow: _ctx.RemoveItem,
              class: "Shadow1",
              TableSettings: _ctx.TableSettings,
              CookiesData: _ctx.TransferItems,
              Search: '',
              Loading: (_ctx.Loading.length > 0),
              Saving: (_ctx.SavingTable.length > 0),
              onInputChanged: _ctx.InputChanged,
              Saved: _ctx.Saved
            }, null, 8, ["onDeleteRow", "TableSettings", "CookiesData", "Loading", "Saving", "onInputChanged", "Saved"])
          ]),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            (_ctx.IsPack || _ctx.DialogData.IsUserSelect)
              ? (_openBlock(), _createBlock(_component_CookiesIcon, {
                  key: 0,
                  onClick: _ctx.AddItem,
                  class: "SQR2_5em HoverGlow",
                  ID: 'Add'
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", null, _toDisplayString(_ctx.Translate('Max')) + ":", 1),
            _createTextVNode(),
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.DialogData.QuantityMax), 1)
          ]),
          _createElementVNode("div", {
            class: "DialogSection F1_5em F-Bold",
            style: _normalizeStyle(_ctx.TotalQuantity > _ctx.DialogData.QuantityMax ? 'color: var(--colorr1);' : '')
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.Translate('Total')) + ":", 1),
            _createTextVNode(),
            _createElementVNode("span", null, _toDisplayString(_ctx.TotalQuantity), 1)
          ], 4)
        ])
      ])
    ], 8, _hoisted_1),
    (_ctx.Access('Inventory_AvailableItems_Override'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
              style: {"background":"var(--colorr1)"},
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.Translate('Close')), 1),
            _createElementVNode("button", {
              class: _normalizeClass([_ctx.TotalQuantity > _ctx.DialogData.QuantityMax ? 'Disabled' : '', "F-Bold CookiesButton DialogFooterButton"]),
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.SaveData && _ctx.SaveData(...args))),
              style: _normalizeStyle('background: ' + _ctx.Theme.UserColors.main)
            }, _toDisplayString(_ctx.Translate('Save')), 7)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}